import { render, staticRenderFns } from "./BusinessStartupPageIndex.vue?vue&type=template&id=4cd2fa86&"
import script from "./BusinessStartupPageIndex.vue?vue&type=script&lang=ts&"
export * from "./BusinessStartupPageIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardTitle,VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd2fa86')) {
      api.createRecord('4cd2fa86', component.options)
    } else {
      api.reload('4cd2fa86', component.options)
    }
    module.hot.accept("./BusinessStartupPageIndex.vue?vue&type=template&id=4cd2fa86&", function () {
      api.rerender('4cd2fa86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/BusinessStartupPageIndex.vue"
export default component.exports